import { StringHelper } from "../../../../../../utilities/contracts/string-helper";

export class ChartRouteFilters {
    constructor(
        readonly memberId: string
    ) {
        this.memberId = StringHelper.clean(memberId);
    }
}
